import { render, staticRenderFns } from "./extpartnerEdit.vue?vue&type=template&id=6167c55d"
import script from "./extpartnerEdit.vue?vue&type=script&lang=js"
export * from "./extpartnerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports